var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgPersonEnvelopeFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Zm0 12A6.75 6.75 0 0 0 5.25 21a.75.75 0 0 0 .75.75h5.524c.173 0 .294-.172.263-.341A2.266 2.266 0 0 1 11.75 21v-4a2.25 2.25 0 0 1 1.002-1.872l.517-.345c.18-.12.132-.39-.08-.427A6.748 6.748 0 0 0 12 14.25Zm4.584.126a.75.75 0 0 1 .832 0l2.28 1.52a.25.25 0 0 1-.027.431l-2.557 1.278a.25.25 0 0 1-.224 0l-2.557-1.278a.25.25 0 0 1-.026-.432l2.279-1.519Zm3.804 3.268a.25.25 0 0 1 .362.224V21a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-3.132a.25.25 0 0 1 .362-.224l3.053 1.527a.75.75 0 0 0 .67 0l3.053-1.527Z", fill: "currentColor" })));
});
export default SvgPersonEnvelopeFill;
